import { render, staticRenderFns } from "./PosterTextProduct.vue?vue&type=template&id=529e53b6&scoped=true&"
import script from "./PosterTextProduct.vue?vue&type=script&lang=js&"
export * from "./PosterTextProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e53b6",
  null
  
)

export default component.exports